/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_Q6Inputs */

const en_pc_dl_faq_q6 = /** @type {(inputs: Pc_Dl_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I check that my download is genuine?`)
};

const zh_pc_dl_faq_q6 = /** @type {(inputs: Pc_Dl_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何确认下载的文件是正版？`)
};

/**
* | output |
* | --- |
* | "How do I check that my download is genuine?" |
*
* @param {Pc_Dl_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_q6 = /** @type {((inputs?: Pc_Dl_Faq_Q6Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_Q6Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_q6(inputs)
	return zh_pc_dl_faq_q6(inputs)
});
export { pc_dl_faq_q6 as "pc.dl.faq.q6" }